import {Component, OnInit} from '@angular/core';
import {faClock} from '@fortawesome/free-regular-svg-icons';
import {faFacebookSquare, faInstagram} from '@fortawesome/free-brands-svg-icons';
import {faPhoneAlt, faMapMarker} from '@fortawesome/free-solid-svg-icons';
import {StoreDetailsService} from '../../../services/store-details.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  public store: any;
  clockIcon = faClock;
  phoneIcon = faPhoneAlt;
  mapIcon = faMapMarker;
  facebookIcon = faFacebookSquare;
  instagramIcon = faInstagram;

  constructor(public storeDetails: StoreDetailsService) {
  }

  ngOnInit() {
    this.store = this.storeDetails.store;
  }

}
